module.exports = require('./dist/commonjs/index.js').default;



//////////////////
// WEBPACK FOOTER
// ./~/i18next-xhr-backend/index.js
// module id = 504
// module chunks = 2